<template>
  <ion-card color="white" class="border-default filter-card mt-zero document-wrapper">
    <div class="document-wrapper__status">
      <TagStatusDocument
        v-if="isFileInputWithValue"
        :status="firstFileInputAnswer?.status ?? DOCUMENT_VERIFICATION_STATUSES.PENDING"
      />
      <TagStatusDocument
        v-else
        :status="document.status ?? DOCUMENT_VERIFICATION_STATUSES.PENDING"
      />
    </div>
    <section v-if="!isFileInputWithValue">
      <div
        class="upload-wrapper"
        v-if="
          document.status !== DOCUMENT_VERIFICATION_STATUSES.PENDING &&
          document.status !== DOCUMENT_VERIFICATION_STATUSES.PENDING_ACCEPTANCE_OR_REVIEW &&
          document.status !== DOCUMENT_VERIFICATION_STATUSES.REJECTED &&
          document.status !== DOCUMENT_VERIFICATION_STATUSES.SIGNED_BY_TENANT_AND_OWNER
        "
      >
        <ion-button
          v-if="document.type != SIGNATURE_TYPES.MANUAL"
          :fill="document.Inputs[0].type !== DOCUMENT_TYPES.CONTRACT ? 'outline' : 'solid'"
          class="padding-x-small padding-y-small mt-8"
          @click="
            document.Inputs[0].type !== DOCUMENT_TYPES.CONTRACT
              ? (toggleUploadPhoto = true)
              : signNow()
          "
        >
          <ion-icon
            :icon="
              document.Inputs[0].type !== DOCUMENT_TYPES.CONTRACT ? cloudUpload : pencilOutline
            "
            class="ion-margin-end"
          ></ion-icon>
          {{
            document.Inputs[0].type !== DOCUMENT_TYPES.CONTRACT
              ? t('actions.upload')
              : t('actions.signNow')
          }}
        </ion-button>
        <ion-button
          v-else
          fill="outline"
          size="small"
          class="padding-x-small padding-y-small mt-8"
          @click="toggleUploadManualContract = true"
        >
          <ion-icon :icon="cloudUploadOutline" class="ion-margin-end"></ion-icon>
          {{ t('actions.upload') }}
        </ion-button>
      </div>
      <div v-else>
        <div class="upload-wrapper__preview">
          <ion-icon :icon="documentOutline" size="large" color="primary"></ion-icon>
          <ion-button
            fill="outline"
            size="small"
            class="padding-x-small padding-y-small mt-8"
            @click="openDownloadSign"
          >
            <ion-icon :icon="eyeOutline" class="ion-margin-end"></ion-icon>
            {{ t('actions.viewFile') }}
          </ion-button>
        </div>
<!--         <div class="show-file-wrapper__menu">
          <DropdownDocumentComponent
            @click:detail="openDetail"
            @click:edit="toggleUploadManualContract = true"
            @click:download="openDownloadSign"
          ></DropdownDocumentComponent>
        </div> -->
      </div>
<!--       <div class="upload-wrapper__menu" v-if="document.type !== SIGNATURE_TYPES.MANUAL">
        <DropdownDocumentContractComponent
          v-if="getDocumentSelected"
          :notSign="true"
          @click:detail="openDetail"
          @click:sign="signNow"
          @click:download="openDownloadSign(getDocumentSelected)"
        ></DropdownDocumentContractComponent>
      </div> -->
    </section>
    <section v-else class="show-file-wrapper">
      <img :src="firstFileInputAnswer?.value" alt="" @click="openDetail" />
      <!-- <div class="show-file-wrapper__menu">
        <DropdownDocumentComponent
          @click:detail="openDetail"
          @click:edit="openEdit"
          @click:download="openDownload"
        ></DropdownDocumentComponent>
      </div> -->
    </section>
    <ion-card-header>
      <p
        class="text-xs text-color-placeholder"
        v-if="firstFileInputAnswer && firstFileInputAnswer?.updatedAt"
      >
        {{ t('profile.latestUpdate') }}
        {{ formatDateTime(firstFileInputAnswer!.updatedAt, locale, true, true) }}
      </p>
      <h4 class="h4 text-weight-bold text-sm text-align-left">
        {{ t('profile.document.' + document.name) }}
      </h4>

      <p
        class="ion-margin-top text-xs text-color-placeholder"
        v-if="firstDateInputAnswer && firstDateInputAnswer?.value"
      >
        {{ t('files.expires.expiration') }}:
      </p>
      <p v-if="firstFileInputAnswer?.value && document.Inputs[0].type !== DOCUMENT_TYPES.CONTRACT">
        {{ formatDateTime(firstDateInputAnswer?.value as string, locale, true, true) }}
      </p>
    </ion-card-header>
  </ion-card>
  <!-- ESTE ES EL MODAL -->
  <ion-modal
    :is-open="toggleUploadPhoto"
    :initial-breakpoint="0.93"
    :breakpoints="[0, 0.25, 0.5, 0.7, 0.93]"
    @will-dismiss="toggleUploadPhoto = false"
  >
    <UploadDocumentModal
      v-if="getDocumentSelected"
      :get-document-selected="getDocumentSelected"
      @close="toggleUploadPhoto = false"
    />
  </ion-modal>
  <ion-modal
    :is-open="toggleUploadManualContract"
    :initial-breakpoint="0.7"
    :breakpoints="[0, 0.25, 0.5, 0.7, 0.93]"
    @will-dismiss="toggleUploadManualContract = false"
  >
    <UploadContractModal
      v-if="getDocumentSelected"
      :get-document-selected="getDocumentSelected"
      :booking-id="bookingId"
      @close="toggleUploadManualContract = false"
    />
  </ion-modal>
</template>

<script setup lang="ts">
  import { IonCard, IonCardHeader, IonButton, IonIcon, IonModal } from '@ionic/vue';
  import {
    cloudUpload,
    cloudUploadOutline,
    documentOutline,
    eyeOutline,
    pencilOutline,
  } from 'ionicons/icons';
  import { computed, onMounted, PropType, ref, watch } from 'vue';
  import { IDocument } from '@/interfaces/profile/profile-document.interface';
  import { useI18n } from 'vue-i18n';
  import { formatDateTime } from '@/utils/date-utils';
  import { IUploadImage } from '@/interfaces/IUploadImage';
  import { useProfile } from '@/composables/useProfile';
  // import DropdownDocumentComponent from '@/components/shared/drop-down/DropdownDocumentComponent.vue';
  // import { CoreStore, useCoreStore } from '@/stores/core-store';
  import router from '@/router';
  import { useBooking } from '@/composables/useBooking';
  import { storeToRefs } from 'pinia';
  import { useBookingStore } from '@/stores/booking-store';
  // import DropdownDocumentContractComponent from '@/components/shared/drop-down/DropdownDocumentContractComponent.vue';
  import {
    DOCUMENT_TYPES,
    DOCUMENT_VERIFICATION_STATUSES,
    SIGNATURE_TYPES,
  } from '@/utils/constants/general-constants';
  import TagStatusDocument from '@/components/shared/TagStatusDocument.vue';
  import UploadDocumentModal from '../profile/documents/UploadDocumentModal.vue';
  import UploadContractModal from '../profile/documents/UploadContractModal.vue';

  const { documentSelected } = useProfile();
  const { handleSignReservationContract, handleDownloadContract } = useBooking();
  const { toggleUploadManualContract } = storeToRefs(useBookingStore());

  const { t, locale } = useI18n();

  const inputSelected = ref();
  const getDocumentSelected = ref<IDocument>();
  const isUpdated = ref<boolean>(false);
  // const coreStore: CoreStore = useCoreStore();

  const props = defineProps({
    hasFile: {
      type: Boolean,
      required: false,
      default: false,
    },
    document: {
      type: Object as PropType<IDocument>,
      required: true,
    },
    bookingId: {
      type: String,
      required: false,
    },
  });

  const toggleUploadPhoto = ref(false);
  const file = ref<IUploadImage>({
    base64: '',
    title: '',
    size: 0,
  });

  const setNewDocumentFile = () => {
    if (props.document?.type !== SIGNATURE_TYPES.MANUAL) {
      inputSelected.value.Answers.push({
        DocumentsMasterInputId: inputSelected.value.id,
        value: file.value.base64,
        size: file.value.size,
      });
      file.value.base64 = '';
      file.value.size = 0;
    }
  };

  const signNow = () => {
    if (props.bookingId) {
      handleSignReservationContract(props.bookingId).then((response) => {
        if (response) {
          if (response) {
            const link = document.createElement('a');
            link.href = response.data?.url ?? '';
            link.target = '_blank';
            link.download = response.data?.url ?? '';
            document.body.appendChild(link);

            link.click();
            document.body.removeChild(link);
          }
        }
      });
    }
  };

  const openDownloadSign = (item: IDocument) => {
    documentSelected.value = item;
    if (props.bookingId) {
      handleDownloadContract(props.bookingId).then((result) => {
        if (result?.data) {
          const blob = new Blob([result?.data], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `contract_${props.bookingId}.pdf`;
          link.click();
        }
      });
    }
  };

  const isFileInputWithValue = computed(() => {
    if (props.document) {
      const fileInput = props.document!.Inputs.find((input) => input.type === 'file');
      if (fileInput && fileInput.Answers.length > 0) {
        return fileInput.Answers[0].value !== '';
      }
    }
    return false;
  });

  const firstFileInputAnswer = computed(() => {
    if (props.document) {
      const fileInput = props.document!.Inputs.find((input) => input.type === 'file');
      if (fileInput && fileInput.Answers.length > 0) {
        return fileInput.Answers[0];
      }
    }
    return null;
  });

  const firstDateInputAnswer = computed(() => {
    if (props.document) {
      const fileInput = props.document!.Inputs.find((input) => input.type === 'date');
      if (fileInput && fileInput.Answers.length > 0) {
        return fileInput.Answers[0];
      }
    }
    return null;
  });

  const openDetail = () => {
    isUpdated.value = false;
    documentSelected.value = getDocumentSelected.value;
    // coreStore.setShowDropdown({ status: false, id: '' });
    router.push('/profile/documents/detail');
  };

  // const openEdit = () => {
  //   isUpdated.value = true;
  //   // coreStore.setShowDropdown({ status: false, id: '' });
  //   documentForm.value = {
  //     numberId: '',
  //     expirationDate:
  //       firstDateInputAnswer.value && firstDateInputAnswer.value
  //         ? firstDateInputAnswer.value.value
  //         : undefined,
  //     renewalDate: '',
  //   };
  //   toggleUploadPhoto.value = true;
  // };

  // const openDownload = () => {
  //   isUpdated.value = false;
  //   coreStore.setShowDropdown({ status: false, id: '' });
  //   const link = document.createElement('a');
  //   link.href = firstFileInputAnswer.value?.value ?? '';
  //   link.download = getDocumentSelected.value?.name ?? '';
  //   document.body.appendChild(link);

  //   link.click();
  //   document.body.removeChild(link);
  // };

  const initialConfig = () => {
    getDocumentSelected.value = props.document;
    documentSelected.value = props.document;
    createAnswerObject();
  };

  const createAnswerObject = () => {
    const dateInputs = getDocumentSelected.value?.Inputs.filter((input) => input.type === 'date');

    if (dateInputs) {
      dateInputs.forEach((input) => {
        if (input.Answers.length === 0) {
          input.Answers.push({
            DocumentsMasterInputId: input.id,
            value: '',
          });
        } else if (!input.Answers[0].id) {
          input.Answers = [];
          input.Answers.push({
            DocumentsMasterInputId: input.id,
            value: '',
          });
        }
      });
    }
  };

  onMounted(() => {
    initialConfig();
  });

  watch(file, (val) => {
    if (val.base64 !== '') {
      setNewDocumentFile();
    }
  });
</script>
<style scoped lang="scss">
  .document-wrapper {
    position: relative;

    &__status {
      position: absolute;
      top: 10px;
      left: 10px;
      z-index: 2;
    }
  }

  ion-content.modal-wrapper {
    --border-radius: 25px;
    --background: white;
  }

  .file-wrapper {
    margin-top: 20px;
    margin-bottom: 30px;
    padding: 10px;
    border-radius: 5px;
    border: 1px solid #d4ddff;
  }

  .show-file-wrapper {
    position: relative;

    img {
      object-fit: cover;
      height: 170px;
      width: 100%;
      cursor: pointer;
    }

    &__menu {
      position: absolute;
      top: 10px;
      right: 10px;
    }
  }

  .upload-wrapper {
    position: relative;
    height: 170px;
    background: #d4ddff66;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &__icon {
      display: flex;
      justify-items: center;
      align-items: center;

      img {
        width: 30px;
        height: 30px;
        margin: 0 auto;
      }
    }

    &__menu {
      position: absolute;
      top: 10px;
      right: 10px;
    }

    &__preview {
      height: 170px;
      width: 100%;
      background: white;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      &__icon {
        width: 100%;
        display: block;
      }

      img {
        width: 100%;
        height: 190px;
        object-fit: cover;
      }

      h1 {
        font-size: 30px;
        font-weight: bold;
        color: white;
      }
    }
  }

  .document-card {
    img {
      width: 44px;
      object-fit: cover;
      height: 44px;
    }
  }

  .modal-wrapper {
    &__pdf {
      img {
        width: 45px;
        height: 40px;
        border-radius: 10px;
      }
    }
  }
</style>
